import {
	PHARMACY_SEARCH_MODULE_REQUEST,
	PHARMACY_SEARCH_MODULE_SUCCESS,
	PHARMACY_SEARCH_MODULE_FAILURE
} from '../../../constants';

const initialState = {
	data: null,
	loading: false,
	error: null,
}

const pharmacySearchModule = (state = initialState, action) => {
	switch (action.type) {
		case PHARMACY_SEARCH_MODULE_REQUEST:
			return {
				...state,
				loading: true,
				data: null,
				error: null,
			};
		case PHARMACY_SEARCH_MODULE_SUCCESS:
			return {
				...state,
				loading: false,
				data: action.payload,
				error: null,
			};
		case PHARMACY_SEARCH_MODULE_FAILURE:
			return {
				...state,
				loading: false,
				error: action.payload,
				data: null,
			};
		default:
			return state;
	}
};

export default pharmacySearchModule;
